import { SET_PAGSEGURO } from '../reducers/pagSeguroReducer';

export const setPagSeguro = (pagSeguro) => ({
    type: SET_PAGSEGURO,
    payload: pagSeguro,
  });